import { useState, useCallback } from 'react';
import axiosInstance from './axiosInstance';

const useFriendRequestHooks = () => {
    const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

   const apiCall = useCallback(async (method, url, data = null) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance({ method, url, data });
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred');
      setLoading(false);
      throw err;
    }
  }, []);

  const getSuggestions = useCallback(async (page = 1) => {
    return await apiCall('get', `/user/friend-request/suggestions?page=${page}`);
  }, [apiCall]);

 const sendFriendRequest = useCallback(async (userId) => {
    return await apiCall('post', `/user/friend-request/send?receiver_id=${userId}`);
  }, [apiCall]);

  const cancelFriendRequest = useCallback(async (reqId) => {
    return await apiCall('delete', `/user/friend-request/cancel/${reqId}`);
  }, [apiCall]);

  const getFriends = useCallback(async (action) => {
    return await apiCall('get', `/user/friend-request/list?type=${action}`);
  }, [apiCall]);

  const acceptFriendRequest = useCallback(async (reqId) => {
    return await apiCall('post', `/user/friend-request/accept/${reqId}`);
  }, [apiCall]);

  const rejectFriendRequest = useCallback(async (reqId) => {
    return await apiCall('post', `/user/friend-request/reject/${reqId}`);
  }, [apiCall]);

  const disconnectFriendRequest = useCallback(async (reqId) => {
    return await apiCall('delete', `/user/friend-request/disconnect/${reqId}`);
  }, [apiCall]);

  // Search people by name
  const searchPeople = useCallback(async (name) => {
    return await apiCall('get', `/user/friend-request/search?query=${name}`);
  }, [apiCall]);

  const getLikeUsers = useCallback(async (postId) => {
    return await apiCall('get', `/user/post/get/user-posts-with-likes/${postId}`);
  }, [apiCall]);

  const updateCurrentLocation = useCallback(async (location) => {
    return await apiCall('post', '/user/current-location', { current_location: location });
  }, [apiCall]);

  const getUserById = useCallback(async (userId) => {
    return await apiCall('get', `/user/get-by-id/${userId}`);
  }, [apiCall]);

  return {
    loading,
    error,
    getUserById,
    getSuggestions,
    sendFriendRequest,
    cancelFriendRequest,
    getFriends,
    acceptFriendRequest,
    rejectFriendRequest,
    searchPeople,
    getLikeUsers,
    updateCurrentLocation,
    disconnectFriendRequest
  };
};

 
export default useFriendRequestHooks;